export default "__VITE_ASSET__7trEXHPd__"